module.exports = __webpack_public_path__ + "static/scale-model-of-jacksonville-florida-0489920b65d028c3f4a537d9b7cbe726.png";